var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeurowideStudioMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.1 38.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #293133;\n      }\n\n      .cls-2 {\n        fill: #c30f0e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.98,37.97L41.38,1.17h10.2l4.6,18.1c.2.9.5,1.9.7,3s.4,2,.6,2.9c.2.8.3,1.4.4,1.8h.5c.2-.9.4-1.9.6-2.9s.4-2,.6-2.9.4-1.6.5-2.1l4.4-17.9h10.1l4.6,18c.2.7.4,1.5.6,2.4s.4,1.9.6,2.9c.2,1,.4,1.8.6,2.5h.4c0-.7.2-1.4.5-2.3s.4-1.8.6-2.7.4-1.8.6-2.5l4.6-18.2h9.4l-11.5,36.8h-10l-4.1-16.5c-.2-.9-.4-1.9-.7-3-.3-1.1-.5-2.2-.7-3.3-.2-1.1-.4-2-.5-2.8h-.4c0,.4,0,1.1-.3,1.9s-.4,1.9-.7,3.1c-.3,1.2-.6,2.5-.9,4l-4.2,16.4h-10.1v.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.28,37.97V1.17h8l.8,5h.5c.8-1.2,1.8-2.3,3-3.2s2.5-1.6,4-2,3.1-.7,4.9-.7,4.6.4,6.4,1.3,3.2,2.3,4.2,4.2c1,1.9,1.5,4.4,1.5,7.5v24.6h-9.7V14.77c0-1.2,0-2.2-.4-3s-.7-1.5-1.2-2-1.2-.9-2-1.2c-.8-.2-1.7-.3-2.7-.3s-2.8.3-3.9,1.1c-1.2.7-2.1,1.7-2.7,2.9s-1,2.6-1,4.2v21.5H2.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurowideStudioMin);
export default __webpack_public_path__ + "static/media/neurowide-studio-min.d08f108877167d66f8a7bf9740417a34.svg";
export { ForwardRef as ReactComponent };